import { isManifest, } from "@jaybeeuu/compost/manifest";
import { is, isObject } from "@jaybeeuu/is";
const isReadingTime = isObject({
    text: is("string"),
    time: is("number"),
    words: is("number"),
    minutes: is("number"),
});
export const isPostInputMetadata = isObject({
    abstract: is("string"),
});
export const isPostManifestEntryCustomProperties = isObject({
    abstract: is("string"),
    readingTime: isReadingTime,
});
export const isPostManifest = isManifest(isPostManifestEntryCustomProperties);
//# sourceMappingURL=types.js.map